<template>
  <div>
    <!-- <FinancialHeader class="mx-5 mt-8" /> -->
    <h2 class="d-flex align-center justify-center mt-8 warningText">
      <Icon icon="mdi-alert-octagon-outline" size="33" color="#212121" class="mr-2" />Aguardando implementação do pagamento
    </h2>
  </div>
</template>

<script>
import Icon from "@/components/atoms/icon";
//import FinancialHeader from "@/components/organisms/Financeiro/financial-header";

export default {
  components: {
    Icon
    // FinancialHeader
  }
};
</script>

<style scoped>
.warningText {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #212121;
}
</style>